import { TreeDataItem } from 'src/app/common/components/CheckboxTree';
import { ETypeOfView } from 'src/app/common/types/view-types';

export const OPERATION_BASE_PATH = '/management';
export const BANNER_BASE_PATH = '/banner';
export const POPUP_BASE_PATH = '/popup';

//  These constants map to aside menu, header menu to display title
export const OPERATION_TITLE = 'title.operation';
export const OPERATION_BANNER_TITLE = 'title.operation.banner';
export const OPERATION_POPUP_TITLE = 'title.operation.popup';

//  These constants map to permission control, identical to permission enum defined below
export const OPERATION_BANNER_NAMESPACE = 'OPERATION-BANNER';
export const OPERATION_POPUP_NAMESPACE = 'OPERATION-POPUP';

export enum AdminOperationPermissionType {
  OPERATION_BANNER_READ = 'READ_ANY_OPERATION-BANNER',
  OPERATION_BANNER_CREATE = 'CREATE_ANY_OPERATION-BANNER',
  OPERATION_BANNER_UPDATE = 'UPDATE_ANY_OPERATION-BANNER',

  OPERATION_POPUP_READ = 'READ_ANY_OPERATION-POPUP',
  OPERATION_POPUP_CREATE = 'CREATE_ANY_OPERATION-POPUP',
  OPERATION_POPUP_UPDATE = 'UPDATE_ANY_OPERATION-POPUP',
}

export const supportLangList = ['vi', 'en'];

export const mainLang = 'vi';
export const subLang = 'en';

export const LINK_TYPE_TRANSLATE_MAP = {
  no: 'component.formSelectItem.no-link',
  app: 'component.formSelectItem.page-in-app',
  external: 'component.formSelectItem.external-url',
};

export const FREQUENCY_TRANSLTAE_MAP = {
  once: 'component.formSelectItem.only-once',
  login: 'component.formSelectItem.after-login',
  daily: 'component.formSelectItem.daily-display',
};

export const MAX_BANNER_PUBLISHED_LIMIT = 10;
export const MAX_POPUP_PUBLISHED_LIMIT = 1;

export const typeOfViewOptions = [
  { value: ETypeOfView.AllTraditionalAgents, label: 'all-traditional-agents' },
  { value: ETypeOfView.Pruventure, label: 'pruventure' },
  { value: ETypeOfView.GroupOfUsers, label: 'group-of-users' },
];

export const TREE_TYPE_OF_VIEWS_DATA: TreeDataItem[] = [
  {
    label: 'Active Traditional Agent',
    value: ETypeOfView.ActiveTraditionalAgents,
    children: [
      {
        label: 'Agent',
        value: ETypeOfView.ActiveTraditionalAgent,
      },
      { label: 'MOA', value: ETypeOfView.ActiveTraditionalMoa },
    ],
  },
  {
    label: 'SA Traditional Agent',
    value: ETypeOfView.SATraditionalAgents,
    children: [
      { label: 'Agent', value: ETypeOfView.SATraditionalAgent },
      { label: 'MOA', value: ETypeOfView.SATraditionalMoa },
    ],
  },
  { label: 'GAD', value: ETypeOfView.GAD },
  { label: 'Agent RED+', value: ETypeOfView.AgentRed },
  { label: 'PRUVenture Agents', value: ETypeOfView.PruventureAgents },
  { label: 'PRUVenture MOA', value: ETypeOfView.PruventureMoa },
  { label: 'Group Of User', value: ETypeOfView.GroupOfUsers },
];

export enum ETypeOfViewCondition {
  SimulationToolAgent = 'simulation-tool-agent',
  SimulationToolMoa = 'simulation-tool-moa',
  SimulationToolGad = 'simulation-tool-gad',
}

export const TYPE_OF_VIEW_CONDITION_MAPPER: Record<
  string,
  Record<string, { checked?: boolean; disabled?: boolean }>
> = {
  [ETypeOfViewCondition.SimulationToolAgent]: {
    [ETypeOfView.AgentRed]: { checked: false, disabled: true },
    [ETypeOfView.PruventureAgents]: { checked: false, disabled: true },
    [ETypeOfView.PruventureMoa]: { checked: false, disabled: true },
  },
  [ETypeOfViewCondition.SimulationToolMoa]: {
    [ETypeOfView.ActiveTraditionalAgent]: { checked: false, disabled: true },
    [ETypeOfView.SATraditionalAgent]: { checked: false, disabled: true },
    [ETypeOfView.AgentRed]: { checked: false, disabled: true },
    [ETypeOfView.PruventureAgents]: { checked: false, disabled: true },
    [ETypeOfView.PruventureMoa]: { checked: false, disabled: true },
  },
  [ETypeOfViewCondition.SimulationToolGad]: {
    [ETypeOfView.ActiveTraditionalAgents]: { checked: false, disabled: true },
    [ETypeOfView.ActiveTraditionalAgent]: { checked: false, disabled: true },
    [ETypeOfView.ActiveTraditionalMoa]: { checked: false, disabled: true },
    [ETypeOfView.SATraditionalAgents]: { checked: false, disabled: true },
    [ETypeOfView.SATraditionalAgent]: { checked: false, disabled: true },
    [ETypeOfView.SATraditionalMoa]: { checked: false, disabled: true },
    [ETypeOfView.AgentRed]: { checked: false, disabled: true },
    [ETypeOfView.PruventureAgents]: { checked: false, disabled: true },
    [ETypeOfView.PruventureMoa]: { checked: false, disabled: true },
  },
};
